import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
  IconButton,
} from "@material-ui/core";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Chart from "src/component/Chart";
import { Link } from "react-router-dom";
import axios from "axios";
import Timer from "./Timer";
import { ICOBaseURL } from "src/ApiConfig/ApiConfig";
const useStyles = makeStyles((theme) => ({
  livePriceBox: {
    "& .pl": {
      paddingLeft: "24px",
    },
    "& .ecilipsBox": {
      left: "21%",
      top: "20%",
      width: " 298px",
      filter: "blur(100px)",
      height: "298px",
      opacity: "0.25",
      backgroundImage:
        "radial-gradient(36.67% 9.68% at 67.26% 8.27%, rgba(255, 0, 205, 0.36) 0, rgb(255 139 95 / 72%) 95.78%)",
    },
    "& .globeshadeImg": {
      top: "-59px",
      width: "auto",
      opacity: "0.5",
      zIndex: "-1",
      position: "absolute",
      maxWidth: "800px",
      left: "0",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
    position: "relative",
    zIndex: "9",
    padding: "50px 0",
    "& .priceTextbox": {
      background: theme.palette.background.card,
      borderRadius: "15px",
      padding: "25px",
      [theme.breakpoints.down("xs")]: {
        padding: "12px",
      },
    },
    "& .livedaysBox": {
      margin: "25px 0",
      background: "rgba(255, 255, 255, 0.02)",
      borderRadius: "8px",
      display: "flex",
      padding: "2px",
      flexWrap: "wrap",
      "& .activeButton": {
        background: theme.palette.background.card,
        width: "51px",
        height: "26px",
        borderRadius: "20px",
        [theme.breakpoints.down("xs")]: {
          margin: "5px 0",
        },
      },
      "& .tabButton": {
        background: theme.palette.background.tabButton,
        width: "51px",
        height: "26px",
        borderRadius: "20px",
        [theme.breakpoints.down("xs")]: {
          margin: "5px 0",
        },
      },
    },
  },
  graphchartBox: {
    boxSizing: "border-box",
    marginTop: "30px",
    background: theme.palette.background.cardinner,
    borderRadius: "8px",
    padding: "10px",
    [theme.breakpoints.down("xs")]: {
      padding: "0px",
    },
    "& .inndergraphBox": {
      border: "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: "8px",
      padding: "15px",
      margin: "15px",
      [theme.breakpoints.down("xs")]: {
        margin: "0px",
      },
    },
  },
}));

function LivePrice() {
  const classes = useStyles();
  // const PriceHandler = async() => {
  //   try {
  //     const res = axios({
  //       method:"GET",
  //       url:"${ICOBaseURL}/wallet/coin/get-coin-details",
  //       params:{
  //         coinName:"Fiero"
  //       }
  //     })

  //     if(res.data){

  //     }
  //   } catch (error) {

  //   }
  // }
  const [newsData, setNewsData] = useState(0);
  const getNewsApiHandler = async (id) => {
    try {
      // setIsLoading(true);
      // const response = await axios({
      //   method: "GET",
      //   url: `${ICOBaseURL}/wallet/coin/get-coin-details?coinName=Fiero`,
      //   // params: {
      //   //   coinName: "Fiero",
      //   // },
      // });
      const response = await axios({
        method: "GET",
        url: `${ICOBaseURL}/wallet/get-sale-list`,
      });

      if (response.data.status === 200) {
        setNewsData(response.data.data?.enabled_sale?.priceWithoutMark);

        // setIsLoading(false);
      }
      // setIsLoading(false);
    } catch (error) {
      console.log(error);
      // setIsLoading(false);
    }
  };
  useEffect(() => {
    getNewsApiHandler();
  }, []);
  return (
    <>
      <Box className={classes.livePriceBox}>
        <img
          src="images/road_banner.png"
          alt="images"
          className="globeshadeImg"
        />

        <Box className="ecilipsBox"></Box>
        {/* <Box className="ecilipsBox1"></Box> */}
        <Container maxWidth="lg">
          <Box className="priceTextbox">
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} lg={7} sm={5} md={7} pr={3} className="pl">
                <AnimationOnScroll animateIn="animate__fadeInLeft">
                  <Typography
                    style={{ whiteSpace: "pre" }}
                    variant="h3"
                    color="primary"
                  >
                    Fiero Price <span style={{ color: "#FF136D" }}>Live </span>
                    Data
                  </Typography>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeInUp">
                  <Box className="displayStart" mt={1} mb={1}>
                    <img src="images/favicon.png" alt="images" width="35px" />
                    <Box ml={2}>
                      <Typography variant="body2" color="primary">
                        Fiero Price
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Typography variant="h3" color="primary">
                      ${newsData ? newsData : ""}
                    </Typography>
                  </Box>
                </AnimationOnScroll>
                <Box mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    // component={Link}
                    href="https://vesting.fieres.io/"
                    target="_blank"
                  >
                    Buy Now
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} lg={5} sm={12} md={5}>
                <Timer />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default LivePrice;
